export type PortalAccountPermissionLevel = 'full' | 'edit' | 'view' | 'none';

export type PortalAccountUser = {
  id: string;
  name: string;
  email: string;
  roleLabel: string;
  statusLabel: string;
  lastAccessLabel: string;
};

export type PortalAccountPermissionRow = {
  id: string;
  moduleLabel: string;
  level: PortalAccountPermissionLevel;
};

export type PortalAccountIntegration = {
  id: string;
  name: string;
  description: string;
  connected: boolean;
  statusLabel: string;
};

export type PortalAccountData = {
  profile: {
    name: string;
    role: string;
    email: string;
    phone: string;
    timezone: string;
    language: string;
    avatarInitials: string;
  };
  company: {
    name: string;
    document: string;
    address: string;
    sector: string;
    website: string;
    contactName: string;
    contactEmail: string;
    contactPhone: string;
  };
  users: PortalAccountUser[];
  permissions: PortalAccountPermissionRow[];
  notificationEvents: { id: string; label: string; enabled: boolean }[];
  notificationChannels: { id: string; label: string; enabled: boolean; icon: 'email' | 'whatsapp' | 'system' }[];
  integrations: PortalAccountIntegration[];
};

export const portalAccountMock: PortalAccountData = {
  profile: {
    name: 'Ana Souza',
    role: 'Analista de negócios',
    email: 'ana.souza@cliente.com.br',
    phone: '(11) 91234-5678',
    timezone: '(GMT-03:00) São Paulo',
    language: 'Português (Brasil)',
    avatarInitials: 'AS',
  },
  company: {
    name: 'Cliente Exemplo S.A.',
    document: 'CNPJ 12.345.678/0001-90',
    address: 'Av. Paulista, 1000 - Bela Vista / São Paulo - SP, 01310-100',
    sector: 'Serviços',
    website: 'www.cliente.com.br',
    contactName: 'Ana Souza',
    contactEmail: 'ana.souza@cliente.com.br',
    contactPhone: '(11) 91234-5678',
  },
  users: [
    {
      id: 'u1',
      name: 'Ana Souza',
      email: 'ana.souza@cliente.com.br',
      roleLabel: 'Administrador',
      statusLabel: 'Ativo',
      lastAccessLabel: 'Hoje, 09:12',
    },
    {
      id: 'u2',
      name: 'João Santos',
      email: 'joao.santos@cliente.com.br',
      roleLabel: 'Patrocinador',
      statusLabel: 'Ativo',
      lastAccessLabel: 'Ontem, 18:40',
    },
    {
      id: 'u3',
      name: 'Fernanda Lima',
      email: 'fernanda.lima@cliente.com.br',
      roleLabel: 'Membro',
      statusLabel: 'Ativo',
      lastAccessLabel: '27/10/2026',
    },
    {
      id: 'u4',
      name: 'Bruno Costa',
      email: 'bruno.costa@cliente.com.br',
      roleLabel: 'Membro',
      statusLabel: 'Convite pendente',
      lastAccessLabel: '—',
    },
  ],
  permissions: [
    { id: 'p1', moduleLabel: 'Projetos', level: 'full' },
    { id: 'p2', moduleLabel: 'Arquivos e documentos', level: 'edit' },
    { id: 'p3', moduleLabel: 'Conversas', level: 'edit' },
    { id: 'p4', moduleLabel: 'Solicitações', level: 'full' },
    { id: 'p5', moduleLabel: 'Relatórios', level: 'view' },
    { id: 'p6', moduleLabel: 'Usuários e permissões', level: 'full' },
  ],
  notificationEvents: [
    { id: 'messages', label: 'Novas mensagens nas conversas', enabled: true },
    { id: 'activities', label: 'Atualizações de atividades', enabled: true },
    { id: 'schedule', label: 'Alterações no cronograma', enabled: true },
    { id: 'requests', label: 'Novas solicitações', enabled: true },
    { id: 'approvals', label: 'Aprovações pendentes', enabled: true },
    { id: 'reports', label: 'Relatórios semanais', enabled: false },
  ],
  notificationChannels: [
    { id: 'email', label: 'E-mail', enabled: true, icon: 'email' },
    { id: 'whatsapp', label: 'WhatsApp', enabled: false, icon: 'whatsapp' },
    { id: 'system', label: 'Notificações no sistema', enabled: true, icon: 'system' },
  ],
  integrations: [
    {
      id: 'calendar',
      name: 'Calendário',
      description: 'Sincronize marcos e reuniões com o calendário da equipe.',
      connected: false,
      statusLabel: 'Não conectado',
    },
    {
      id: 'storage',
      name: 'Armazenamento de arquivos',
      description: 'Vincule uma pasta compartilhada para anexos e documentos.',
      connected: true,
      statusLabel: 'Conectado',
    },
    {
      id: 'sso',
      name: 'Login corporativo',
      description: 'Autenticação única da organização (quando autorizado).',
      connected: false,
      statusLabel: 'Indisponível nesta organização',
    },
  ],
};
